// extracted by mini-css-extract-plugin
module.exports = {"navbarToolbar":"NavbarAlt_navbarToolbar__KGmDv","navbarButton":"NavbarAlt_navbarButton__1rRiQ"};